import React, { useEffect, useRef, useState } from "react";
import { Row, Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Home from "../Pages/Home";
import About from "../Pages/About";
import Services from "../Pages/Services";
import Software from "../Pages/Software";
import Hardware from "../Pages/Hardware";
import Robotics from "../Pages/Robotics"
import Industrial_iot from "../Pages/Industrial_iot"
import Adas from "../Pages/Adas"
import Agri from "../Pages/Agri"
import WaterQuality from "../Pages/WaterQuality"
import Atalkits from "../Pages/Atalkits"
import Lora from "../Pages/Lora"
import Contact from "../Pages/Contact";
import companyLogo from "../Images/LOGO.png";
import iso from "../Images/iso.png";
import InternshipPage from "../Pages/InternshipPage";
import OneCreditCourse from '../Pages/OneCreditCourse';
import ThreeCreditCourse from '../Pages/ThreeCreditCourse';
import { FaEnvelope, FaUser, FaBook} from 'react-icons/fa';
import Chatbot from "./ChatBot";
import './Menubar.css';

export default function Menubar() {
  const navbarScroll = useRef(null);
  const [menucolor, setMenuColor] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const [hoveredDropdown, setHoveredDropdown] = useState(null);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      navbarScroll.current.classList.add("navbarBg");
      setMenuColor(true);
    } else {
      navbarScroll.current.classList.remove("navbarBg");
      setMenuColor(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDropdownHover = (dropdownId, isEntering) => {
    if (isEntering) {
      setHoveredDropdown(dropdownId);
    } else {
      setHoveredDropdown(null);
    }
  };

  return (
    <Router basename="">
      <style jsx>{`
        /* Hide dropdown icons only for main menu items, not submenus */
        .navbar-nav > .nav-item > .dropdown-toggle::after {
          display: none !important;
        }
        
        /* Keep submenu icons visible */
        .dropdown-submenu .dropdown-toggle::after {
          display: inline-block !important;
        }
      `}</style>
      
      <Row className="no-gutters fixed-top" ref={navbarScroll}>
        <Container>
          <Row>
            <div className="w-100">
              <Navbar expand="sm" expanded={expanded} className={menucolor ? "scrollLink" : ""}>
                <Navbar.Brand>
                  <NavLink to="/" exact className="blackColor text-decoration-none d-flex align-items-center">
                    <img src={companyLogo} alt="Internship in 5G" style={{ height: "60px" }} />
                  </NavLink>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mx-auto menu-items">
                    <NavLink to="/" exact className="nav-link" onClick={() => setExpanded(false)}>Home</NavLink>
                    
                    {/* Industry Dropdown */}
                    <NavDropdown
                      title="For Industry"
                      id="industry-dropdown"
                      show={hoveredDropdown === 'industry'}
                      onMouseEnter={() => handleDropdownHover('industry', true)}
                      onMouseLeave={() => handleDropdownHover('industry', false)}
                    >
                      <NavDropdown.Item as={NavLink} to="/Software" onClick={() => setExpanded(false)}>
                            Software Automation
                          </NavDropdown.Item>
                      <NavDropdown.Item as={NavLink} to="/Hardware" onClick={() => setExpanded(false)}>
                        Hardware Automation
                      </NavDropdown.Item>
                      <NavDropdown.Item as={NavLink} to="/Robotics" onClick={() => setExpanded(false)}>
                        Industrial Robotics 
                      </NavDropdown.Item>
                      <NavDropdown
                        title="Industrial IoT"
                        id="industrial-iot-dropdown"
                        drop="start"
                        className="dropdown-submenu"
                      >
                        <NavDropdown
                          title="Industrial IoT Gateways"
                          id="iot-gateways-dropdown"
                          drop="start"
                          className="dropdown-submenu"
                        >
                          <NavDropdown.Item as={NavLink} to="/Industrial_iot" onClick={() => setExpanded(false)}>
                            MPC-311
                          </NavDropdown.Item>
                          <NavDropdown.Item>
                            UCM-316
                          </NavDropdown.Item>
                          <NavDropdown.Item>
                            MPC-730
                          </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown.Item>
                          IP65/IP68 Dataloggers
                        </NavDropdown.Item>
                        <NavDropdown
                          title="Wireless Modbus Bridges"
                          id="modbus-dropdown"
                          drop="start"
                          className="dropdown-submenu"
                        >
                          <NavDropdown.Item>
                            DM-108
                          </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown
                          title="Data Acquisition Modules"
                          id="data-acquisition-dropdown"
                          drop="start"
                          className="dropdown-submenu"
                        >
                          <NavDropdown.Item>
                            AIM-8
                          </NavDropdown.Item>
                          <NavDropdown.Item>
                            DIN-32
                          </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown
                          title="M-Bus Converters"
                          id="mbus-converter-dropdown"
                          drop="start"
                          className="dropdown-submenu"
                        >
                          <NavDropdown.Item>
                            RS485/RS232 to M-Bus Converter
                          </NavDropdown.Item>
                        </NavDropdown>
                      </NavDropdown>
                      <NavDropdown.Item as={NavLink} to="/Adas" onClick={() => setExpanded(false)}>
                        ADAS
                      </NavDropdown.Item>
                      <NavDropdown.Item as={NavLink} to="/Agri" onClick={() => setExpanded(false)}>
                        Precision Agriculture
                      </NavDropdown.Item>
                      <NavDropdown.Item as={NavLink} to="/WaterQuality" onClick={() => setExpanded(false)}>
                        Water Quality Management
                      </NavDropdown.Item>
                      <NavDropdown.Item as={NavLink} to="/Atalkits" onClick={() => setExpanded(false)}>
                        Atal Kits
                      </NavDropdown.Item>
                      <NavDropdown.Item as={NavLink} to="/Lora" onClick={() => setExpanded(false)}>
                        LoRa
                      </NavDropdown.Item>
                    </NavDropdown>

                    {/* Academics Dropdown */}
                    <NavDropdown
                      title="For Academics"
                      id="academics-dropdown"
                      show={hoveredDropdown === 'academics'}
                      onMouseEnter={() => handleDropdownHover('academics', true)}
                      onMouseLeave={() => handleDropdownHover('academics', false)}
                    >
                      <NavDropdown
                        title="L&D"
                        id="ld-dropdown"
                        drop="start"
                        className="dropdown-submenu"
                      >
                        <NavDropdown
                          title="Credit Course"
                          id="credit-course-dropdown"
                          drop="start"
                          className="dropdown-submenu"
                        >
                          <NavDropdown.Item as={NavLink} to="/credit-course-1" onClick={() => setExpanded(false)}>
                            One Credit Course
                          </NavDropdown.Item>
                          <NavDropdown.Item as={NavLink} to="/credit-course-3" onClick={() => setExpanded(false)}>
                            Three Credit Course
                          </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown.Item as={NavLink} to="/Internship" onClick={() => setExpanded(false)}>
                          Internship
                        </NavDropdown.Item>
                      </NavDropdown>
                      <NavDropdown.Item>
                        COE-IOT,AI SETUP
                      </NavDropdown.Item>
                    </NavDropdown>

                    {/* Online Store Dropdown */}
                    <NavDropdown
                      title="Online Store"
                      id="online-store-dropdown"
                      show={hoveredDropdown === 'store'}
                      onMouseEnter={() => handleDropdownHover('store', true)}
                      onMouseLeave={() => handleDropdownHover('store', false)}
                    >
                      <NavDropdown.Item href="https://www.coimbatronics.in/" target="_blank" rel="noopener noreferrer">
                        Coimbatronics
                      </NavDropdown.Item>
                      <NavDropdown.Item href="https://seller.indiamart.com/" target="_blank" rel="noopener noreferrer">
                        India Mart
                      </NavDropdown.Item>
                      <NavDropdown.Item href="https://mti.tradeindia.com/my-tradeindia/index.html" target="_blank" rel="noopener noreferrer">
                        TradeIndia
                      </NavDropdown.Item>
                    </NavDropdown>

                    <NavLink to="/About" className="nav-link" onClick={() => setExpanded(false)}>About Us</NavLink>
                    <NavLink to="/Contact" className="nav-link" onClick={() => setExpanded(false)}>Contact Us</NavLink>
                  </Nav>
                  <div className="right-icons d-flex align-items-center">
                    <img src={iso} alt="iso" className="d-none d-sm-block iso-image" />
                    <a className="mail-icon-container" href="https://krishtec.co.in/webmail">
                      <FaEnvelope className="icon" />
                    </a>
                    <a className="profile-icon-container" href="https://www.zoho.com/people/login.html">
                      <FaUser className="icon" />
                    </a>
                    <a className="book-icon-container" href="https://www.iot.krishtec.co.in/">
                      <FaBook className="icon" />
                    </a>
                  </div>
                </Navbar.Collapse>
              </Navbar>
            </div>
          </Row>
        </Container>
      </Row>
      <ScrollToTop>
        <Route exact path="/" component={Home} />
        <Route path="/About" component={About} />
        <Route path="/services" component={Services}/>
        <Route path="/Software" component={Software} />
        <Route path="/Hardware" component={Hardware} />
        <Route path="/Robotics" component={Robotics} />
        <Route path="/Industrial_iot" component={Industrial_iot} />
        <Route path="/Adas" component={Adas} />
        <Route path="/Agri" component={Agri} />
        <Route path="/WaterQuality" component={WaterQuality} />
        <Route path="/Atalkits" component={Atalkits} />
        <Route path="/Lora" component={Lora} />
        <Route path="/Contact" component={Contact} />
        <Route path="/Internship" component={InternshipPage} />
        <Route path="/credit-course-1" component={OneCreditCourse} />
        <Route path="/credit-course-3" component={ThreeCreditCourse} />
      </ScrollToTop>
      <Chatbot />
    </Router>
  );
}